import { css } from '@emotion/react';

export type EllipsisLine = number;

export const ellipsisBasicStyle = css({
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-all'
});

export const getEllipsisStyle = (ellipsis: number) => {
  if (ellipsis === 1) {
    return [
      ellipsisBasicStyle,
      css({
        whiteSpace: 'pre-line',
        WebkitLineClamp: ellipsis
      })
    ];
  }

  return [
    ellipsisBasicStyle,
    css({
      display: '-webkit-box',
      WebkitLineClamp: ellipsis
    })
  ];
};
